import { MutationTree } from "vuex";
import { IEmployeeGradeState } from "../types";
import { IEmployeeGrade } from "@/core/interfaces/employeeGrade.interface";

const mutations: MutationTree<IEmployeeGradeState> = {
  setEmployeeGrades(state, payload: IEmployeeGrade[]) {
    state.employeeGrades = payload;
  },
  setFetchingEmployeeGrades(state, payload: boolean) {
    state.isFetchingEmployeeGrades = payload;
  },
  setEmployeeGradeActionLoading(state, payload: boolean) {
    state.employeeGradeActionLoading = payload;
  },
};

export default mutations;
